class UserEnvironment { 

    navigatorObject = null;
    windowObject = null;

    constructor(navigatorObject, windowObject){
        this.navigatorObject = navigatorObject;
        this.windowObject = windowObject;
    }

    browserVersion() {
        let ua= this.navigatorObject.userAgent, tem, 
        M= ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
        if(/trident/i.test(M[1])){
            tem=  /\brv[ :]+(\d+)/g.exec(ua) || [];
            return 'IE '+(tem[1] || '');
        }
        if(this.navigatorObject.userAgent.indexOf("Edg") >= 0){
            let edgIndex = this.navigatorObject.userAgent.indexOf("Edg");
            let edgNode = this.navigatorObject.userAgent.substring(edgIndex, this.navigatorObject.userAgent.length - 1);
            let edgVersion = edgNode.split("/")[1];
            return 'Edge ' + edgVersion;
        }
        if(M[1]=== 'Chrome'){
            tem= ua.match(/\bOPR\/(\d+)/)
            if(tem!= null) return 'Opera '+tem[1];
        }
        M= M[2]? [M[1], M[2]]: [this.navigatorObject.appName, this.navigatorObject.appVersion, '-?'];
        if((tem= ua.match(/version\/(\d+)/i))!= null) M.splice(1, 1, tem[1]);
        return M.join(' ');
    }

    osVersion() {
        let osName = "Unknown (OS)";
        if (this.navigatorObject.appVersion.indexOf("Win") >= 0) osName="Windows";
        if (this.navigatorObject.appVersion.indexOf("Mac") >= 0) osName="MacOS";
        if (this.navigatorObject.appVersion.indexOf("X11") >= 0) osName="UNIX";
        if (this.navigatorObject.appVersion.indexOf("Linux") >= 0) osName="Linux";
        if (this.navigatorObject.userAgent.indexOf("Android") >= 0) osName = "Android";
        if (this.navigatorObject.userAgent.indexOf("like Mac") >= 0) osName = "iOS";
        return osName + " (APP_VERSION: " + this.navigatorObject.appVersion + ", USER_AGENT: " + this.navigatorObject.userAgent + ")";
    }

    screenDimension() {
        let windowScreenWidth = this.windowObject.screen.width;
        let windowScreenHeight = this.windowObject.screen.height;
        let nativeScreenWidth = windowScreenWidth * this.windowObject.devicePixelRatio;
        let nativeScreenHeight = windowScreenHeight * this.windowObject.devicePixelRatio;
        return "window:" + windowScreenWidth + "x" + windowScreenHeight + ",native:" + nativeScreenWidth + "x" + nativeScreenHeight;
    }
}

export default UserEnvironment;
